module.exports = __webpack_public_path__ + "img/86cc697.png";